import { useRef, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import {
  UserRegistrationButton,
  SelectMakeMyHomeOrNot,
  TermsAndConditions,
} from './UserRegistrationUI';
import {
  DisplayMnemonic,
  DisplayWif,
  DisplayAddress,
  GetThePrivateKeyFromTheMnemonic,
  UnregisterAddress,
  UnregisterCredential,
  SavePasswordEncryptedSecrets,
  LoadPasswordEncryptedSecrets,
} from './SettingAll';
import {
  SelectWalletBox,
  SelectSessionButton,
  SelectAddressFromKeypoolSection,
} from './KeysAndSigningUI';
import {
  Header,
  UserName,
  ForDevelopment,
  Footer,
} from './MonacottoMiscUI';
import {
  TextLine3,
  TextArea2,
} from './UtilComponents';
import {
  useGlobalStateSelector,
  words,
  stateKeysToSetAddress,
  stateKeysToSetUserName,
} from './globalState';
import {
  handleClickMpurse,
} from './keysAndSigning';
import {
  handleClickAddressHistory,
} from './monacottoMisc';
import {
  devLog,
} from './utils';
import iconMpurse from './mpurse.png';
import iconList from './format_list_bulleted_FILL0_wght400_GRAD0_opsz48.svg';

// MANAGEMENT SCREEN
function ManagementScreen() {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const cookies = useGlobalStateSelector( ({ cookies }) => cookies );
  const setCookie = useGlobalStateSelector( ({ setCookie }) => setCookie );
  const removeCookie = useGlobalStateSelector( ({ removeCookie }) => removeCookie );
  const inputImageFile = useRef(null);

  const onDropAccepted = useCallback((acceptedFiles) => {
    devLog('acceptedFiles', acceptedFiles);
    dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'imagesNew', 'main'], value: acceptedFiles[0] });
    const dataUrl = URL.createObjectURL(acceptedFiles[0]);
    devLog('dataUrl', dataUrl);
    dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'imagesNew', 'mainUrl'], value: dataUrl });
  }, []);

  const maxFiles = 1;
  const accept = {
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/gif': ['.gif'],
  };

  const { getRootProps, getInputProps, acceptedFiles, fileRejections } = useDropzone({ onDropAccepted, maxFiles, accept });

  const dropZoneStyle = {
    width: '24em',
    height: '18em',
    border: "1px dotted #888",
  };

  // アドレスセクション・スイッチアイコン

  let addressSection;

  if (state.walletType === 'keypool') {
    addressSection =
    <SelectAddressFromKeypoolSection
      stateKeys={['configure', 'addressMain']}
      stateKeysToSetAddress={stateKeysToSetAddress}
      stateKeysToSetUserName={stateKeysToSetUserName}
      loginEnabled={false}
      setConfigure={true}
      subAddressEnabled={true}
    />;
  }


  return (
    <div>
      {/* PC */}
      <div className="mainMonacotto invisibleSp">
        <Header screen='managementScreen' />
        {/* configure */}
        <div className='flexRow justifyContentCenter' >
          <div className='flexColumn alignItemsCenter margin1' >
            <div className='flexColumn alignItemsFlexStart' >
              <SelectWalletBox keypoolButtonVisible={true} />
              {/* address main */}
              {/*
                <div className='flexRow alignItemsCenter' >
                  <AddressIfNotHiddenSections keys={['configure', 'addressMain']} />
                  <AddressHistoryIfNotHiddenSections keys={['configure', 'addressMain']} />
                </div>
              */}
              <div className='marginTop0p5 '>
                { addressSection }
              </div>
              {/* user name */}
              <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
                <UserName keys={['configure', 'userName']} />
                {/* <SwitchIcon /> */}
              </div>
              {/* default address */}
              <div className='borderMonacotto backgroundColorTransparent padding1 marginTop1'>
                <div>
                  {words.addressDefaultOptional[state.language]}
                </div>
                <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
                  <TextLine3 fieldName='addressCardFromDefault' keys={['configure', 'addressCardFromDefault']}
                    face={words.addressCardFrom[state.language]} tooltip={true}
                  />
                  <SelectSessionButton stateKeysToSetAddress={[['configure', 'addressCardFromDefault']]} stateKeysToSetUserName={[]} />
                  <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['configure', 'addressCardFromDefault']) }>
                    <img className='size2x2' src={iconMpurse} alt= '' />
                  </button>
                  <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['configure', 'addressCardFromDefault']) }>
                    <img className='size2x2' src={iconList} alt= '' />
                  </button>
                </div>
                <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
                  <TextLine3 fieldName='addressPayProceedsToDefault' keys={['configure', 'addressPayProceedsToDefault']}
                    face={words.addressPayProceedsTo[state.language]} tooltip={true}
                  />
                  <SelectSessionButton stateKeysToSetAddress={[['configure', 'addressPayProceedsToDefault']]} stateKeysToSetUserName={[]} />
                  <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['configure', 'addressPayProceedsToDefault']) }>
                    <img className='size2x2' src={iconMpurse} alt= '' />
                  </button>
                  <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['configure', 'addressPayProceedsToDefault']) }>
                    <img className='size2x2' src={iconList} alt= '' />
                  </button>
                </div>
                <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
                  <TextLine3 fieldName='addressPayFromDefault' keys={['configure', 'addressPayFromDefault']}
                    face={words.addressPayFrom[state.language]} tooltip={true}
                  />
                  <SelectSessionButton stateKeysToSetAddress={[['configure', 'addressPayFromDefault']]} stateKeysToSetUserName={[]} />
                  <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['configure', 'addressPayFromDefault']) }>
                    <img className='size2x2' src={iconMpurse} alt= '' />
                  </button>
                  <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['configure', 'addressPayFromDefault']) }>
                    <img className='size2x2' src={iconList} alt= '' />
                  </button>
                </div>
                <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
                  <TextLine3 fieldName='addressSendCardToDefault' keys={['configure', 'addressSendCardToDefault']}
                    face={words.addressSendCardTo[state.language]} tooltip={true}
                  />
                  <SelectSessionButton stateKeysToSetAddress={[['configure', 'addressSendCardToDefault']]} stateKeysToSetUserName={[]} />
                  <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['configure', 'addressSendCardToDefault']) }>
                    <img className='size2x2' src={iconMpurse} alt= '' />
                  </button>
                  <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['configure', 'addressSendCardToDefault']) }>
                    <img className='size2x2' src={iconList} alt= '' />
                  </button>
                </div>
              </div>
              {/* my home */}
              <SelectMakeMyHomeOrNot />
              {/* terms and conditions */}
              <div className='flexColumn alignItemsFlexStart '>
                <TermsAndConditions />
              </div>
            </div>
          </div>
          <div className='flexColumn alignItemsCenter margin1'>
            {/* image */}
            <div className='relative margin1 '>
                <div {...getRootProps()} style={dropZoneStyle} >
                  <input {...getInputProps} style={{ display: 'none' }} />
                  <div className='padding0p5'>
                    {words.mainImageWithDescription[state.language]}<br/>
                    {words.dragAndDrop[state.language]}<br/>
                  </div>
                </div>
                {
                  state.configure.imagesNew.mainUrl !== undefined && state.configure.imagesNew.mainUrl !== null ?
                  <img className='mainImageAbsolute' src={state.configure.imagesNew.mainUrl} alt='mainImage' />
                  : null
                }
            </div>
            {/* profile text */}
            <TextArea2 fieldName='attributedTextText' keys={['configure', 'profileText']} face={words.profileText[state.language]} boxClass='box4 margin1' textAreaClass='textArea1' />
            <UserRegistrationButton />
          </div>
          {/* others */}
          <div className='flexColumn alignItemsCenter margin1'>
            {/* clear address history */}
            <button className='borderNone backgroundColorWhite textLeft focusEffect01 cursor borderRadius2 riseOut2 margin1 ' tabindex='0'
              onClick={ () => {
                removeCookie('addresses');
                dispatch({ type: 'setNotification', key: 'notification', value: words.clearedAddressHistory[state.language] });
              } }>
              {words.clearAddressHistory[state.language]}
            </button>
            {/* address check */}
            <div className='flexColumn alignItemsFlexStart margin1'>
              <div className=''>
                {words.addressCheck[state.language]}
              </div>
              <div className='flexRow justifyContentCenter'>
                <button className={'box3 focusEffect01 riseOut2 ' + (state.addressCheck === 'off' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                  onClick={ () => {
                    dispatch({type: 'setState', key: 'addressCheck', value: 'off'});
                    setCookie('addressCheck', 'off', { maxAge: state.config.clientParameters.cookie.addressCheck.maxAge, secure: true, sameSite: 'strict' });
                  }}>
                  {words.off[state.language]}
                </button>
                <button className={'box3 focusEffect01 riseOut2 ' + (state.addressCheck === 'strict' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                  onClick={ () => {
                    dispatch({type: 'setState', key: 'addressCheck', value: 'strict'});
                    setCookie('addressCheck', 'strict', { maxAge: state.config.clientParameters.cookie.addressCheck.maxAge, secure: true, sameSite: 'strict' });
                  }}>
                  {words.on[state.language]}
                </button>
                <button className={'box3 focusEffect01 riseOut2 ' + (state.addressCheck === 'addressSecond' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                  onClick={ () => {
                    dispatch({type: 'setState', key: 'addressCheck', value: 'addressSecond'});
                    setCookie('addressCheck', 'addressSecond', { maxAge: state.config.clientParameters.cookie.addressCheck.maxAge, secure: true, sameSite: 'strict' });
                  }}>
                  {words.allowTheSecondAddress[state.language]}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className='flexRow justifyContentCenter' >
          <div className='flexColumn alignItemsCenter margin1'>
            <DisplayMnemonic />
          </div>
          <div className='flexColumn alignItemsCenter margin1'>
            <DisplayWif />
            <DisplayAddress />
            <GetThePrivateKeyFromTheMnemonic />
          </div>
          <div className='flexColumn alignItemsCenter margin1'>
            <UnregisterAddress />
            <UnregisterCredential />
            <SavePasswordEncryptedSecrets />
            <LoadPasswordEncryptedSecrets />
          </div>
        </div>
        {/* development */}
        <div className=''>
          { process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null }
          { process.env.REACT_APP_ENVIRONMENT === 'dev' ? 'acceptedFiles' + JSON.stringify(acceptedFiles) : null }
          { process.env.REACT_APP_ENVIRONMENT === 'dev' ? 'fileRejections' + JSON.stringify(fileRejections) : null }
        </div>
        <Footer />
      </div>
      {/* SP */}
      <div className="flexColumn mainMonacotto widthMax invisiblePc">
        <Header screen='managementScreen' />
        {/* configure */}
        <div className='flexColumn alignItemsCenter widthMax ' >
          <div className='borderTopBottom marginTopBottom1'>
            {words.userRegistration[state.language]}
          </div>
          <SelectWalletBox keypoolButtonVisible={true} />
          {/* address main */}
          {/*
            <div className='flexRow alignItemsCenter' >
              <AddressIfNotHiddenSections keys={['configure', 'addressMain']} />
              <AddressHistoryIfNotHiddenSections keys={['configure', 'addressMain']} />
            </div>
          */}
          <div className='marginTop0p5 '>
            { addressSection }
          </div>
          {/* user name */}
          <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
            <UserName keys={['configure', 'userName']} />
            {/* <SwitchIcon /> */}
          </div>
          {/* default address */}
          <div className='borderMonacotto backgroundColorTransparent padding1 marginTop1'>
            <div>
              {words.addressDefaultOptional[state.language]}
            </div>
            {/* addressCardFrom */}
            <TextLine3 fieldName='addressCardFromDefault' keys={['configure', 'addressCardFromDefault']}
              face={words.addressCardFrom[state.language]} tooltip={true}
            />
            <div className='flexRow justifyContentFlexStart alignItemsCenter '>
              <SelectSessionButton stateKeysToSetAddress={[['configure', 'addressCardFromDefault']]} stateKeysToSetUserName={[]} />
              <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['configure', 'addressCardFromDefault']) }>
                <img className='size2x2' src={iconMpurse} alt='' />
              </button>
              <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['configure', 'addressCardFromDefault']) }>
                <img className='size2x2' src={iconList} alt='' />
              </button>
            </div>
            {/* addressPayProceedsTo */}
            <TextLine3 fieldName='addressPayProceedsToDefault' keys={['configure', 'addressPayProceedsToDefault']}
              face={words.addressPayProceedsTo[state.language]} tooltip={true}
            />
            <div className='flexRow justifyContentFlexStart alignItemsCenter '>
              <SelectSessionButton stateKeysToSetAddress={[['configure', 'addressPayProceedsToDefault']]} stateKeysToSetUserName={[]} />
              <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['configure', 'addressPayProceedsToDefault']) }>
                <img className='size2x2' src={iconMpurse} alt='' />
              </button>
              <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['configure', 'addressPayProceedsToDefault']) }>
                <img className='size2x2' src={iconList} alt='' />
              </button>
            </div>
            {/* addressPayFrom */}
            <TextLine3 fieldName='addressPayFromDefault' keys={['configure', 'addressPayFromDefault']}
              face={words.addressPayFrom[state.language]} tooltip={true}
            />
            <div className='flexRow justifyContentFlexStart alignItemsCenter '>
              <SelectSessionButton stateKeysToSetAddress={[['configure', 'addressPayFromDefault']]} stateKeysToSetUserName={[]} />
              <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['configure', 'addressPayFromDefault']) }>
                <img className='size2x2' src={iconMpurse} alt='' />
              </button>
              <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['configure', 'addressPayFromDefault']) }>
                <img className='size2x2' src={iconList} alt='' />
              </button>
            </div>
            {/* addressSendCardTo */}
            <TextLine3 fieldName='addressSendCardToDefault' keys={['configure', 'addressSendCardToDefault']}
              face={words.addressSendCardTo[state.language]} tooltip={true}
            />
            <div className='flexRow justifyContentFlexStart alignItemsCenter '>
              <SelectSessionButton stateKeysToSetAddress={[['configure', 'addressSendCardToDefault']]} stateKeysToSetUserName={[]} />
              <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['configure', 'addressSendCardToDefault']) }>
                <img className='size2x2' src={iconMpurse} alt='' />
              </button>
              <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['configure', 'addressSendCardToDefault']) }>
                <img className='size2x2' src={iconList} alt='' />
              </button>
            </div>
          </div>
          {/* my home */}
          <SelectMakeMyHomeOrNot />
          {/* image */}
          <input ref={inputImageFile} className='invisible' type='file' accept='image/png, .png, image/jpeg, .jpg, .jpeg, image/gif, .gif' 
            onChange={ (e) => {
              devLog('acceptedFiles', JSON.stringify(e.currentTarget.files[0].name));
              dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'imagesNew', 'main'], value: e.currentTarget.files[0] });
              const dataUrl = URL.createObjectURL(e.currentTarget.files[0]);
              devLog('dataUrl', dataUrl);
              dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'imagesNew', 'mainUrl'], value: dataUrl });
            }}
          />
          <button className='mainImageContainer flexColumn justifyContentFlexStart margin1 ' onClick={ () => { inputImageFile.current.click(); } }>
            <div className='padding0p5 textLeft'>
              {words.mainImageWithDescription[state.language]}<br/>
              {words.click[state.language]}<br/>
            </div>
            {
              state.configure.imagesNew.mainUrl !== undefined && state.configure.imagesNew.mainUrl !== null ?
              <img className='mainImageAbsolute' src={state.configure.imagesNew.mainUrl} alt='' />
              : null
            }
          </button>
          {/* profile text */}
          <TextArea2 fieldName='attributedTextText' keys={['configure', 'profileText']} face={words.profileText[state.language]}
            outerClass='widthMax' boxClass='box4 ' textAreaClass='textArea1'
          />
          {/* terms and conditions */}
          <div className='flexColumn alignItemsFlexStart '>
            <TermsAndConditions />
          </div>
          <UserRegistrationButton />
          {/* others */}
          <div className='borderTopBottom marginTopBottom1'>
            {words.otherSettings[state.language]}
          </div>
          <button className='borderNone backgroundColorWhite textLeft focusEffect01 cursor borderRadius2 riseOut2 margin1 ' tabindex='0'
            onClick={ () => {
              removeCookie('addresses');
              dispatch({ type: 'setNotification', key: 'notification', value: words.clearedAddressHistory[state.language] });
            } }>
            {words.clearAddressHistory[state.language]}
          </button>
          {/* address check */}
          <div className='flexColumn alignItemsFlexStart margin1'>
            <div className=''>
              {words.addressCheck[state.language]}
            </div>
            <div className='flexRow justifyContentCenter'>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.addressCheck === 'off' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                  dispatch({type: 'setState', key: 'addressCheck', value: 'off'});
                  setCookie('addressCheck', 'off', { maxAge: state.config.clientParameters.cookie.addressCheck.maxAge, secure: true, sameSite: 'strict' });
                }}>
                {words.off[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.addressCheck === 'strict' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                  dispatch({type: 'setState', key: 'addressCheck', value: 'strict'});
                  setCookie('addressCheck', 'strict', { maxAge: state.config.clientParameters.cookie.addressCheck.maxAge, secure: true, sameSite: 'strict' });
                }}>
                {words.on[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.addressCheck === 'addressSecond' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                  dispatch({type: 'setState', key: 'addressCheck', value: 'addressSecond'});
                  setCookie('addressCheck', 'addressSecond', { maxAge: state.config.clientParameters.cookie.addressCheck.maxAge, secure: true, sameSite: 'strict' });
                }}>
                {words.allowTheSecondAddress[state.language]}
              </button>
            </div>
          </div>
          <div className='flexColumn alignItemsCenter marginTopBottom1 ' >
            <DisplayMnemonic />
            <DisplayWif />
            <DisplayAddress />
            <GetThePrivateKeyFromTheMnemonic />
            <UnregisterAddress />
            <UnregisterCredential />
            <SavePasswordEncryptedSecrets />
            <LoadPasswordEncryptedSecrets />
          </div>
        </div>
        {/* development */}
        <Footer />
      </div>
    </div>
  );
}

export { ManagementScreen };
